'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

MultiViewDirective=function(_BaseControllerBacked){_inherits(MultiViewDirective,_BaseControllerBacked);function MultiViewDirective(){_classCallCheck(this,MultiViewDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(MultiViewDirective,[{key:'objectBindings',get:function()
{
return['views','selectedView','self'];
}},{key:'textBindings',get:function()

{
return['stickyId'];
}},{key:'templateUrl',get:function()

{
return'/templates/directives/multiViewDirective/multiViewTemplate';
}},{key:'controller',get:function()

{
return MultiViewDirectiveController;
}}]);return MultiViewDirective}(BaseControllerBackedDirective);let


MultiViewDirectiveController=function(){_createClass(MultiViewDirectiveController,null,[{key:'$inject',get:function()
{
return['$scope','$state','$compile','$element','displaySettingsService'];
}}]);

function MultiViewDirectiveController($scope,$state,$compile,$element,displaySettingsService){var _this2=this;_classCallCheck(this,MultiViewDirectiveController);
this._$scope=$scope;
this._$state=$state;
this._$compile=$compile;
this._$element=$element;
this._displaySettingsService=displaySettingsService;

this._$scope.$on('$destroy',function(){
if(_.exists(_this2._currentViewScope)){
_this2._currentViewScope.$destroy();
}
});

this._$scope.$watch(`controller._$state.params["${this.stickyId}TabSelection"]`,function(newIndex,oldIndex){
if(!_.exists(newIndex)||newIndex===oldIndex){
return;
}

if(newIndex===-1){
_this2._selectDefaultIndex();
return;
}

_this2.selectViewAtIndex(newIndex);
});

this._selectDefaultIndex();
}MultiViewDirectiveController.prototype.

_selectDefaultIndex=function _selectDefaultIndex(){
const lastSelectedIndex=this._displaySettingsService.getMultiViewSelectionFor(this.stickyId);
const paramIndex=_.get(this._$state,`params["${this.stickyId}TabSelection"]`);

this.select(this.views[paramIndex]||this.views[lastSelectedIndex]||this.views[0]);
};MultiViewDirectiveController.prototype.

select=function select(view){
if(!_.exists(view)){
this._selectDefaultIndex();
return;
}

if(this._selectedView===view){
return;
}

this._loadView(view);
this._displaySettingsService.setMultiViewSelection(this.stickyId,this.views.indexOf(view));
};MultiViewDirectiveController.prototype.









selectViewAtIndex=function selectViewAtIndex(index){
this.select(this.views[index]);
};MultiViewDirectiveController.prototype.

reloadCurrentView=function reloadCurrentView(){
this._loadView(this._selectedView);
};MultiViewDirectiveController.prototype.

_loadView=function _loadView(view){
this._selectedView=view;

let inflatedBindings='';
if(_.exists(view.bindings)){
for(let binding in view.bindings){
inflatedBindings+=` ${binding}=$parent.$parent.${view.bindings[binding]}`;
}
}

if(_.exists(this._currentViewScope)){
this._currentViewScope.$destroy();
}

this._currentViewScope=this._$scope.$new(!0,this._$scope);
this._currentView.innerHTML=`<${view.directiveName} ${inflatedBindings} multi-view-parent='$parent.controller'></${view.directiveName}>`;

this._$compile(this._currentView)(this._currentViewScope);

const stateName=_.get(this._$state,'current.name');
this._$state.go(stateName,{
[this.stickyId+'TabSelection']:this.views.indexOf(view)});

};_createClass(MultiViewDirectiveController,[{key:'self',get:function(){return this},set:function(nope){}},{key:'selectedView',get:function()

{
return this._selectedView;
},set:function(

val){

}},{key:'_currentView',get:function()

{
return this.__currentView||(this.__currentView=this._$element.find('.current-view')[0]);
}}]);return MultiViewDirectiveController}();



module.exports=MultiViewDirective;
//# sourceMappingURL=multiViewDirective.js.map
